import { lazy, Suspense } from "react";
import { LazyLoader } from "../../../assets/loaders";

const LazyComponent = lazy(() => import("./ResetPassword"));

const index = () => {
  return (
    <Suspense fallback={<LazyLoader />}>
      <LazyComponent />
    </Suspense>
  );
};

export default index;
